/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInboundFaxNoteDto
 */
export interface UpdateInboundFaxNoteDto {
    /**
     * Free-text note for this fax. Pass null to clear.
     * @type {object}
     * @memberof UpdateInboundFaxNoteDto
     */
    note?: object | null;
}

/**
 * Check if a given object implements the UpdateInboundFaxNoteDto interface.
 */
export function instanceOfUpdateInboundFaxNoteDto(value: object): value is UpdateInboundFaxNoteDto {
    return true;
}

export function UpdateInboundFaxNoteDtoFromJSON(json: any): UpdateInboundFaxNoteDto {
    return UpdateInboundFaxNoteDtoFromJSONTyped(json, false);
}

export function UpdateInboundFaxNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInboundFaxNoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateInboundFaxNoteDtoToJSON(json: any): UpdateInboundFaxNoteDto {
    return UpdateInboundFaxNoteDtoToJSONTyped(json, false);
}

export function UpdateInboundFaxNoteDtoToJSONTyped(value?: UpdateInboundFaxNoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

